import React from 'react';
import { 
    Card, 
    CardContent, 
    Typography, 
    Accordion, 
    AccordionSummary, 
    AccordionDetails,
    Box,
    IconButton
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const StyledCard = styled(Card)(({ theme }) => ({
    maxWidth: 500,
    margin: '2rem auto',
    position: 'relative',
    minHeight: 400,
    transition: 'all 0.3s ease',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    borderRadius: '16px',
    background: 'linear-gradient(to bottom, #ffffff, #fafafa)'
}));

const StyledAccordion = styled(Accordion)(({ theme }) => ({
    boxShadow: 'none',
    '&:before': {
        display: 'none',
    },
    '&.Mui-expanded': {
        margin: 0,
    },
    backgroundColor: 'transparent',
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    padding: theme.spacing(0, 2),
    '& .MuiAccordionSummary-content': {
        margin: theme.spacing(2, 0),
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
        color: theme.palette.primary.main,
    },
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2, 3),
    backgroundColor: '#f8f9fa',
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(0, 2, 2),
}));

const FAQTitle = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    fontSize: '1.5rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    padding: theme.spacing(3),
    borderBottom: '1px solid #eaeaea',
}));

const faqs = [
    {
        question: "What cryptocurrencies do you accept?",
        answer: "We accept various cryptocurrencies including SOL and SPL tokens on the Solana network, BASE, and BSC. We will soon support."
    },
    {
        question: "How long does it take to process a payment?",
        answer: "Payments are typically confirmed within 1-2 minutes after the transaction is sent. The payment status is updated in real-time on the payment page."
    },
    {
        question: "What happens if I send the wrong amount?",
        answer: "If you send less than the required amount, you'll need to send the remaining balance. If you send more, please contact the merchant for assistance."
    },
    {
        question: "Are there any transaction fees?",
        answer: "Network transaction fees (gas fees) apply to all cryptocurrency transactions. These fees go to the network validators, not to us."
    },
    {
        question: "What if I need help with my payment?",
        answer: "You can contact the merchant directly using the email provided on the payment page, or use the 'Help' menu for additional options."
    },
    {
        question: "What if I sent a payment but it's not showing up?",
        answer: "Please verify your payment manually by clicking the 'Verify Payment' button. If you are still having issues, please contact the merchant"
    }
];


const FAQs = ({ onBack }) => {
    return (
        <StyledCard>
            {onBack && (
                <IconButton 
                    onClick={onBack}
                    sx={{ position: 'absolute', top: 16, left: 16 }}
                >
                    <ArrowBackIcon />
                </IconButton>
            )}

            <FAQTitle>
                PEPAY FAQs
            </FAQTitle>
            <CardContent>
                <Box sx={{ mt: 2 }}>
                    {faqs.map((faq, index) => (
                        <StyledAccordion key={index}>
                            <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography sx={{ fontWeight: 500 }}>
                                    {faq.question}
                                </Typography>
                            </StyledAccordionSummary>
                            <StyledAccordionDetails>
                                <Typography>
                                    {faq.answer}
                                </Typography>
                            </StyledAccordionDetails>
                        </StyledAccordion>
                    ))}
                </Box>
            </CardContent>
        </StyledCard>
    );
};

export default FAQs;